const React = require("react");

require("./UnauthorizedError.less");

const authenticator = require("~/authenticator.js");
const authenticationDispatchers = require("~/events/authentication/authenticationDispatchers.js");
const ErrorType = require("~/types/Error.js").PropType;

const MajorError = require("../MajorError/MajorError.jsx");

const UnauthorizedError = React.createClass({
    propTypes: {
        Error: ErrorType.isRequired
    },
    render() {
        return (<div className="cs-UnauthorizedError">
            <h1 className="cs-UnauthorizedError__header">
                Looks like you're not allowed&nbsp;to&nbsp;do&nbsp;that.
            </h1>
            <MajorError Error={this.props.Error } />
            <ul className="cs-UnauthorizedError__list">
                <li className="cs-UnauthorizedError__list-item">
                    First thing to do is try it again.
                    <button className="btn btn-primary cs-UnauthorizedError__button"
                            onClick={this.ClearError}>
                        Click here to give it another shot.
                    </button>
                </li>
                <li className="cs-UnauthorizedError__list-item">
                    If you already tried that,
                    <button className="btn btn-primary cs-UnauthorizedError__button"
                            onClick={this.Reload}>
                        Click here to reload the page.
                    </button>
                </li>
                <li className="cs-UnauthorizedError__list-item">
                    If you already tried that too, please contact
                    Support Services.
                </li>
            </ul>
        </div>);
    },
    ClearError() {
        authenticationDispatchers.ClearError();
    },
    Reload() {
        window.location.reload(true);
    }
});

module.exports = UnauthorizedError;


// WEBPACK FOOTER //
// ./src/components/UnauthorizedError/UnauthorizedError.jsx